if (!customElements.get('product-info')) {
  customElements.define('product-info', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.form = this.querySelector('product-form form');
        this.picker = this.querySelector('[data-lf-variant]');
        if (!this.form || !this.picker) return;
        try { this.variants = JSON.parse(this.querySelector('[data-lf-product-data]').textContent).variants; }
        catch { this.fail(); return; }
        if (!Array.isArray(this.variants)) { this.fail(); return; }
        this.picker.addEventListener('change', () => this.update(true), { signal: this.controller.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-lf-gallery-image]');
          if (button && this.contains(button)) this.showImage(button.dataset.lfGalleryImage, button.dataset.lfGalleryAlt);
        }, { signal: this.controller.signal });
        this.form.querySelector('[data-lf-plan]')?.addEventListener('change', () => this.update(false), { signal: this.controller.signal });
        this.form.addEventListener('submit', event => {
          if (!this.current?.available || this.invalid) event.preventDefault();
        }, { signal: this.controller.signal });
        window.addEventListener('pageshow', () => this.update(false), { signal: this.controller.signal });
        window.addEventListener('popstate', () => {
          if (!this.id.startsWith('MainProduct-')) return;
          const id = new URL(window.location.href).searchParams.get('variant');
          if (id && this.variants.some(v => String(v.id) === id)) this.picker.value = id;
          this.update(false);
        }, { signal: this.controller.signal });
        this.update(false);
        customElements.whenDefined('lumera-sticky-selection').then(() => { if (this.isConnected) this.update(false); });
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
    showImage(src, alt) {
      const image = this.querySelector('.lf-main-product-image');
      if (!src || !image) return;
      image.removeAttribute('srcset');
      image.src = src;
      image.alt = alt || this.dataset.lfTitle || '';
      for (const button of this.querySelectorAll('[data-lf-gallery-image]')) button.setAttribute('aria-pressed', String(button.dataset.lfGalleryImage === src));
    }
    fail() {
      this.invalid = true;
      this.form?.querySelector('[type="submit"]')?.setAttribute('disabled', 'disabled');
      this.dispatchEvent(new CustomEvent('product-info:variant-error'));
      const status = this.querySelector('[data-lf-product-status]');
      if (status) status.textContent = this.dataset.unavailable;
      this.dispatchEvent(new CustomEvent('lumera:selection', { bubbles: true, detail: { productId: this.dataset.productId, ready: false, external: this.dataset.provider === 'true', url: '', summary: this.dataset.unavailable } }));
    }
    update(changeURL) {
      if (!this.variants || !this.picker || !this.form) return;
      this.dispatchEvent(new CustomEvent('product-info:variant-pending'));
      const variant = this.variants.find(v => String(v.id) === this.picker.value);
      if (!variant) { this.fail(); return; }
      this.invalid = false;
      this.current = variant;
      this.form.querySelector('[name="id"]').value = variant.id;
      const submit = this.form.querySelector('[type="submit"]');
      const planSelect = this.form.querySelector('[data-lf-plan]');
      const plans = variant.plans || [];
      if (planSelect) {
        for (const option of planSelect.options) option.disabled = Boolean(option.value) && !plans.some(plan => String(plan.id) === option.value);
        if (planSelect.selectedOptions[0]?.disabled || !planSelect.selectedOptions.length) planSelect.value = [...planSelect.options].find(option => !option.disabled)?.value || '';
      }
      const plan = plans.find(plan => String(plan.id) === planSelect?.value);
      const validPlan = !planSelect || !planSelect.value && [...planSelect.options].some(option => option.value === '') || Boolean(plan);
      submit.disabled = !variant.available || !validPlan;
      submit.textContent = variant.available ? this.dataset.add : this.dataset.soldOut;
      const price = this.querySelector('[data-lf-price]');
      if (price) price.textContent = plan?.price || variant.price;
      this.showImage(variant.image || this.dataset.lfFallbackImage, variant.image ? variant.imageAlt || variant.title : this.dataset.lfFallbackAlt);
      const summary = this.querySelector('[data-lf-selection-label]');
      if (summary) summary.textContent = variant.title;
      const status = this.querySelector('[data-lf-product-status]');
      if (status) status.textContent = variant.available && validPlan ? '' : this.dataset.unavailable;
      this.dispatchEvent(new CustomEvent('product-info:variant-ready', { detail: { variant } }));
      if (!this.querySelector('lumera-external-buy')) {
        this.dispatchEvent(new CustomEvent('lumera:selection', { bubbles: true, detail: { productId: this.dataset.productId, ready: variant.available && validPlan, external: false, url: '', summary: variant.title, label: this.dataset.add } }));
      }
      if (changeURL && this.id.startsWith('MainProduct-')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
  });
}

document.addEventListener('click', event => {
  const menu = event.target.closest('.menu-button');
  if (menu) {
    const panel = document.getElementById(menu.getAttribute('aria-controls'));
    if (!panel) return;
    const open = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  }
  if (event.target.closest('#lf-mobile-menu a')) {
    document.getElementById('lf-mobile-menu').hidden = true;
    document.querySelector('.menu-button')?.setAttribute('aria-expanded', 'false');
  }
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const panel = document.getElementById('lf-mobile-menu');
  if (panel && !panel.hidden) { panel.hidden = true; const button=document.querySelector('.menu-button'); button?.setAttribute('aria-expanded','false'); button?.focus(); }
});

const quickDialog = document.getElementById('lf-quick-dialog');
if (quickDialog) {
  const content=quickDialog.querySelector('[data-lf-quick-content]');
  const status=quickDialog.querySelector('[data-lf-quick-status]');
  const copy=JSON.parse(document.getElementById('lf-runtime-copy').textContent);
  let request, generation=0;
  const clean=()=>{generation++;request?.abort();content.replaceChildren();status.textContent='';};
  quickDialog.addEventListener('close',clean);
  quickDialog.querySelector('[data-lf-close]').addEventListener('click',()=>quickDialog.close());
  document.addEventListener('click',async event=>{
    const trigger=event.target.closest('[data-lf-quick]');
    if(!trigger)return;
    const url=new URL(trigger.dataset.lfQuick,location.origin);
    if(url.origin!==location.origin)return;
    clean();const active=++generation;
    const fullURL=url.href;
    url.searchParams.set('section_id','lf-product');
    request=new AbortController();
    quickDialog.showModal();status.textContent=copy.loading;
    try{
      const response=await fetch(url,{signal:request.signal});
      if(!response.ok)throw new Error('Preview unavailable');
      const html=await response.text();
      if(active!==generation||!quickDialog.open)return;
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const product=parsed.querySelector('product-info');
      if(!product)throw new Error('Missing product');
      const prefix='QuickView-'+active+'-';
      const ids=new Map([...product.querySelectorAll('[id]')].map(node=>[node.getAttribute('id'),prefix+node.getAttribute('id')]));
      product.id=prefix+product.id.replace('MainProduct-','');
      for(const node of product.querySelectorAll('[id]'))node.setAttribute('id',ids.get(node.getAttribute('id')));
      for(const node of product.querySelectorAll('[for]'))if(ids.has(node.getAttribute('for')))node.setAttribute('for',ids.get(node.getAttribute('for')));
      for(const node of product.querySelectorAll('[data-form-id]'))node.dataset.formId=ids.get(node.dataset.formId);
      const safetyLink=product.querySelector('.safety-snippet a');
      if(safetyLink) safetyLink.setAttribute('href',fullURL+(safetyLink.getAttribute('href') || '#product-details'));
      const link=document.createElement('a');link.className='plain-link';link.href=fullURL;link.textContent=copy.full_page;
      content.replaceChildren(document.importNode(product,true),link);
      status.textContent='';
    }catch(error){
      if(active!==generation||error.name==='AbortError')return;
      status.textContent=copy.failed;
      const link=document.createElement('a');link.href=fullURL;link.className='button';link.textContent=copy.full_page;content.replaceChildren(link);
    }
  });
}

document.addEventListener('shopify:section:load',()=>{
  document.querySelectorAll('product-info').forEach(product=>product.update?.(false));
});
